// Styles here will override Bulma styles
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const StyledDocument = styled.div`
  max-width: 870px;
  margin: auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;

  h1 {
    margin: 32px 0 16px 0 !important;
  }

  h2 {
    font-family: 'WorkSans-Bold';
  }

  h3,
  h4,
  h5,
  h6 {
    font-family: 'WorkSans-Regular';
  }

  p img {
    margin: 16px 0;
    max-width: 100%;
  }
`;

export const styledCardsSection = css`
  background-repeat: repeat;
`;

export const styledCardsContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${media('<desktop')} {
    h2,
    p {
      margin-left: 20px;
      margin-right: 20px;
      text-align: center;
    }
  }
`;

export const styledHeading = css`
  text-align: left;
`;

export const styledSubheading = css`
  margin: 20px auto 20px 0 !important;
  max-width: 670px;
  text-align: left;
`;

export const styledLightRichText = css`
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #fff;
    font-weight: normal;
  }

  p a {
    font-family: 'WorkSans-Regular';
    text-decoration: underline;
    color: #0069ff;
  }

  strong {
    font-family: 'WorkSans-Bold';
    font-weight: normal;
  }

  ul {
    margin-left: 32px;
    li {
      padding: 8px 0;
    }
  }
`;

export const styledDarkRichText = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #031b4e !important;
    margin-top: 32px;
    margin-bottom: 16px;
  }

  h1,
  h2 {
    font-weight: 400;
  }

  p,
  span,
  ul,
  ol {
    color: #5b6987;
  }

  a {
    font-family: 'WorkSans-Regular';
    text-decoration: underline;
    color: #0069ff !important;
  }

  ul,
  ol {
    margin-left: 32px;
    li {
      padding: 8px 0;
    }
  }
`;

export const styledModal = css`
  position: fixed;
  top: 100px;
  ${media('<desktop')} {
    top: 20px;
  }
`;

export const StyledModalContent = styled.div`
  max-width: 770px;
  min-height: 575px;
  background: #fff;
  border-radius: 6px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${media('<desktop')} {
    width: 100%;
  }
`;

export const StyledModalHeader = styled.div`
  border-bottom: 1px solid #f3f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const styledModalTitle = css`
  text-align: left;
  padding: 24px !important;
  line-height: 110% !important;
`;

export const StyledCloseBtn = styled.a`
  padding: 24px 20px;
  position: relative;
  height: 15px;
  width: 15px;
  cursor: pointer;

  :before,
  :after {
    position: absolute;
    content: ' ';
    height: 15px;
    width: 2px;
    background-color: #5b6987;
  }

  :before {
    transform: rotate(45deg);
  }
  :after {
    transform: rotate(-45deg);
  }
`;

export const StyledModalCopy = styled.div`
  height: 330px;
  padding: 48px 48px 0 48px;
  overflow: scroll;
  color: #5b6987;
`;

export const StyledButtonContainer = styled.div`
  margin: 32px 48px 48px 48px;

  .is-primary {
    margin-right: 16px;
    ${media('<tablet')} {
      margin-top: 16px;
      width: 100%;
    }
  }
`;

export const StyledModalTextLink = styled.div`
  max-width: 870px;
  margin: auto;
  text-align: left;
  display: flex;
  overflow-wrap: break-word;

  a {
    display: inline;
    font-family: 'WorkSans-Regular';
    text-decoration: underline;
    color: #0069ff;
  }

  a:hover {
    cursor: pointer;
  }
`;

export const styleSection = css`
  #trustCertSectionOne {
    padding-bottom: 0;

    p.block-img {
      text-align: center;
    }
  }

  #trustCertSectionTwo {
    padding-top: 0;
    padding-bottom: 50px;

    h3 {
      margin-top: 0;
    }

    p.block-img {
      text-align: center;
    }
  }
`;
